// Copyright (c) StrangeBee 2023

import client from '@Client';
import useDebounce from '@Hooks/useDebounce';
import React, { useState } from 'react';
import { THTagSelector, THTagSelectorProps } from './THTagSelector';

type AutocompleteProps = THTagSelectorProps;

export const Autocomplete = ({ value, onChange, options, taxonomies, ...props }: AutocompleteProps) => {
    const { debounce } = useDebounce();
    const [tags, setTags] = useState<string[]>([]);

    const fetchTags = async (tag: string) => {
        const data = await client.TaxonomyController.list<string[]>({
            selector: {
                head: [{ name: 'tagAutoComplete', freeTag: tag, limit: 20 }],
                name: 'tags-auto-complete',
            },
        });
        setTags(data);
    };

    return (
        <THTagSelector
            taxonomies={taxonomies}
            value={value}
            onSearch={
                taxonomies
                    ? (value) => {
                          if (value?.length >= 3) {
                              debounce({
                                  onTimeout: () => {
                                      fetchTags(value);
                                  },
                                  timeoutDelay: 1000,
                              });
                          }
                      }
                    : undefined
            }
            onChange={(value, options) => {
                onChange?.(value, options);
                setTags([]);
            }}
            options={[...(options || []), ...tags.map((value) => ({ label: value, value }))]}
            {...props}
        />
    );
};
